import { tAttachment } from './Chat.types';

// INT-1708: WhatsApp's animated "Lottie" stickers arrive from whatsmeow as a
// zip (`.was`) holding a Lottie JSON, not an image, so an <img> cannot show
// them. The socket delivers them as IMAGE and the history as STICKER; the
// mimetype is the only thing both paths agree on.
const LOTTIE_STICKER_MIME_TYPE = 'application/was';

export function isLottieSticker(
  attachment: Pick<tAttachment, 'mimeType'> | null | undefined,
): boolean {
  const mimeType = attachment?.mimeType?.split(';')[0].trim().toLowerCase();
  return mimeType === LOTTIE_STICKER_MIME_TYPE;
}
